import { render, staticRenderFns } from "./ApplicableType.vue?vue&type=template&id=f087c592&scoped=true"
import script from "./ApplicableType.vue?vue&type=script&lang=js"
export * from "./ApplicableType.vue?vue&type=script&lang=js"
import style0 from "./ApplicableType.vue?vue&type=style&index=0&id=f087c592&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f087c592",
  null
  
)

export default component.exports